import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-modal-mover",
  templateUrl: "./modal-mover.component.html",
  standalone: false,
})
export class ModalMoverComponent {
  @Output() move = new EventEmitter<MouseEvent>();

  onMouseDown(event: MouseEvent): void {
    this.move.emit(event);
  }
}
